import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { fmt } from './format';
import { SHAPES, VIEWBOX } from './nigeriaMap';
const ZONES = ['North Central', 'North East', 'North West', 'South East', 'South South', 'South West'];

/** /data-hub/states: every state (map + list by region), each opening its state page */
export default class StatesIndexPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'DataHubFull';
    this.states = null;
    this.query = '';
    this.hover = null;
    app.setTitle("Nigeria's states");
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/datahub/states',
      errorHandler: () => {}
    }).then(r => {
      this.states = r && r.states || [];
    }).catch(() => {
      this.states = [];
    }).finally(() => m.redraw());
  }
  open(e, slug) {
    if (e && (e.ctrlKey || e.metaKey)) return;
    if (e) e.preventDefault();
    m.route.set('/data-hub/states/' + slug);
  }
  view() {
    const q = this.query.trim().toLowerCase();
    const list = (this.states || []).filter(s => !q || [s.name, s.capital, s.zone, s.governor].join(' ').toLowerCase().includes(q));
    const zoneOf = s => s.zone || 'Other';
    const zones = ZONES.concat(Array.from(new Set(list.map(zoneOf))).filter(z => !ZONES.includes(z)));
    const hovered = this.hover && (this.states || []).find(s => s.slug === this.hover);
    return m("div", {
      className: "DataHubFull-page"
    }, m("section", {
      className: "DHHero DHState-hero"
    }, m("div", {
      className: "container DHHero-inner"
    }, m("div", {
      className: "DHHero-text"
    }, m("a", {
      className: "DataHubPub-back",
      href: "/data-hub",
      onclick: e => {
        e.preventDefault();
        m.route.set('/data-hub');
      }
    }, m("i", {
      className: "fas fa-arrow-left"
    }), " Data Hub"), m("div", {
      className: "DHHero-eyebrow"
    }, "State profiles"), m("h1", null, "Nigeria's 36 states and the FCT"), m("p", null, "Pick a state for its leadership, economy, budget, resources, security and election news on one page."), m("div", {
      className: "DHHero-search"
    }, m("i", {
      className: "fas fa-search"
    }), m("input", {
      className: "FormControl",
      placeholder: "Find a state, capital or governor",
      value: this.query,
      oninput: e => this.query = e.target.value
    }))), m("div", {
      className: "DHState-locator is-index"
    }, m("svg", {
      viewBox: VIEWBOX,
      role: "img",
      "aria-label": "Map of Nigeria's states"
    }, Object.entries(SHAPES).map(([slug, path]) => m("path", {
      d: path,
      className: (this.hover === slug ? 'is-this' : '') + (q && !list.some(s => s.slug === slug) ? ' is-dim' : ''),
      onmouseenter: () => this.hover = slug,
      onmouseleave: () => this.hover = null,
      onclick: () => this.open(null, slug)
    }))), m("p", {
      className: "DHMuted DHState-hoverName"
    }, hovered ? hovered.name + (hovered.governor ? ' · ' + hovered.governor : '') : 'Tap a state on the map')))), m("div", {
      className: "container DHState"
    }, !this.states ? m(LoadingIndicator, null) : !list.length ? m("p", {
      className: "DHMuted"
    }, "No state matches \u201C", this.query.trim(), "\u201D.") : zones.map(z => {
      const rows = list.filter(s => zoneOf(s) === z);
      if (!rows.length) return null;
      return m("section", {
        className: "DHSection"
      }, m("div", {
        className: "DHSection-head"
      }, m("h2", null, z)), m("div", {
        className: "DHState-cards"
      }, rows.map(s => m("a", {
        className: 'DHState-card' + (this.hover === s.slug ? ' is-hover' : ''),
        href: '/data-hub/states/' + s.slug,
        onclick: e => this.open(e, s.slug),
        onmouseenter: () => this.hover = s.slug,
        onmouseleave: () => this.hover = null
      }, s.photo ? m("img", {
        src: s.photo,
        alt: "",
        loading: "lazy"
      }) : m("span", {
        className: "DHState-cardIcon"
      }, m("i", {
        className: "fas fa-map-marker-alt"
      })), m("span", {
        className: "DHState-cardText"
      }, m("strong", null, s.slug === 'abuja' ? 'FCT Abuja' : s.name), m("span", {
        className: "DHMuted"
      }, [s.capital, s.population ? fmt(s.population, 'people', true) + ' people' : null].filter(Boolean).join(' · ')), s.governor ? m("span", {
        className: "DHMuted"
      }, s.governor, s.party ? ' (' + s.party + ')' : '') : null), s.rank ? m("span", {
        className: "DHState-cardRank"
      }, "#", s.rank) : null))));
    })));
  }
}